module.exports = __webpack_public_path__ + "static/media/mob-affi.2fccefa5.webp";